export default __webpack_public_path__ + "static/media/photo--lg--ayaka.8619dd94.jpg";